export default function createTextLengthLimiterPlugin(
  maxLength,
  maxLengthReachedCallback
) {
  // noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
  return {
    handlePastedText(pastedText, html, editorState) {
      if (maxLength === 0) {
        // there is no limit, allow it
        return;
      }
      const currentContent = editorState.getCurrentContent();
      const currentContentLength = currentContent.getPlainText("").length;
      const selectedTextLength = getLengthOfSelectedText(editorState);

      if (
        currentContentLength + pastedText.length - selectedTextLength >
        maxLength
      ) {
        maxLengthReachedCallback();
        return "handled";
      }
    },
    handleBeforeInput(chars, editorState, eventTimeStamp, pluginFunctions) {
      if (maxLength === 0) {
        // there is no limit, allow it
        return;
      }
      const currentContent = editorState.getCurrentContent();
      const currentContentLength = currentContent.getPlainText("").length;
      const selectedTextLength = getLengthOfSelectedText(editorState);

      if (currentContentLength - selectedTextLength > maxLength - 1) {
        maxLengthReachedCallback();
        return "handled";
      }
    }
  };
}

function getLengthOfSelectedText(editorState) {
  const currentSelection = editorState.getSelection();
  const isCollapsed = currentSelection.isCollapsed();

  let length = 0;

  if (!isCollapsed) {
    const currentContent = editorState.getCurrentContent();
    const startKey = currentSelection.getStartKey();
    const endKey = currentSelection.getEndKey();
    const startBlock = currentContent.getBlockForKey(startKey);
    const isStartAndEndBlockAreTheSame = startKey === endKey;
    const startBlockTextLength = startBlock.getLength();
    const startSelectedTextLength =
      startBlockTextLength - currentSelection.getStartOffset();
    const endSelectedTextLength = currentSelection.getEndOffset();
    const keyAfterEnd = currentContent.getKeyAfter(endKey);

    if (isStartAndEndBlockAreTheSame) {
      length +=
        currentSelection.getEndOffset() - currentSelection.getStartOffset();
    } else {
      let currentKey = startKey;

      while (currentKey && currentKey !== keyAfterEnd) {
        if (currentKey === startKey) {
          length += startSelectedTextLength + 1;
        } else if (currentKey === endKey) {
          length += endSelectedTextLength;
        } else {
          length += currentContent.getBlockForKey(currentKey).getLength() + 1;
        }

        currentKey = currentContent.getKeyAfter(currentKey);
      }
    }
  }

  return length;
}
